import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce'
import { useContext, useEffect, useRef } from 'react'
import { logMessage } from './Logging'

export function logAuthContext() {
  const authContext = useContext<IAuthContext>(AuthContext)
  const { error } = authContext
  useEffect(() => {
    if (error) {
      logMessage(`AuthContext error: ${error}`, 'error', 'AuthDebug')
    }
  }, [error])

  const prev = useRef<unknown>({})

  useEffect(() => {
    const idTokenExp = typeof authContext.idTokenData?.exp === 'number' ? authContext.idTokenData.exp : null
    const now = Math.floor(Date.now() / 1000)
    const snapshot = {
      loginInProgress: authContext.loginInProgress,
      tokenTail: authContext.token ? authContext.token.slice(-12) : null,
      exp: typeof authContext.tokenData?.exp === 'number' ? authContext.tokenData.exp : null,
      now,
      secondsLeft: typeof authContext.tokenData?.exp === 'number' ? authContext.tokenData.exp - now : null,
      error: authContext.error,
      idTokenPresent: !!authContext.idToken,
      idTokenExp,
      idTokenSecondsLeft: idTokenExp ? idTokenExp - now : null,
    }

    const snapshotStr = JSON.stringify(snapshot)
    const changed = snapshotStr !== JSON.stringify(prev.current)
    if (changed) {
      logMessage(snapshotStr, 'debug', 'AuthDebug')
      prev.current = snapshot
    }
  }, [authContext])
}
